// Static emergency data per country — used as fallback/supplement to Claude-generated data
// Sources: Official embassy websites & country emergency services
// Last updated: 2026

export const EMERGENCY_DATA = {
  // ── Europe ─────────────────────────────────────────────────────────────────
  SPAIN: {
    police: "091 (Police nationale) / 112",
    pompiers: "080 / 112",
    samu: "061 / 112",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Espagne",
      adresse: "Calle Salustiano Olózaga 9, 28001 Madrid",
      telephone: "+34 91 423 89 00",
      telephone_urgence: "+34 91 423 89 00",
      site: "https://es.ambafrance.org",
    },
  },
  PORTUGAL: {
    police: "112 / 217 654 242",
    pompiers: "112",
    samu: "112",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France au Portugal",
      adresse: "Rua Santos-o-Velho 5, 1249-079 Lisbonne",
      telephone: "+351 21 391 39 00",
      telephone_urgence: "+351 21 391 39 00",
      site: "https://pt.ambafrance.org",
    },
  },
  ITALY: {
    police: "113 (Police d'État) / 112",
    pompiers: "115",
    samu: "118",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Italie",
      adresse: "Piazza Farnese 67, 00186 Rome",
      telephone: "+39 06 68 60 11",
      telephone_urgence: "+39 06 68 60 11",
      site: "https://it.ambafrance.org",
    },
  },
  GREECE: {
    police: "100 / 112",
    pompiers: "199",
    samu: "166",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Grèce",
      adresse: "7 Vasilissis Sofias Avenue, 10671 Athènes",
      telephone: "+30 210 339 1000",
      telephone_urgence: "+30 210 339 1000",
      site: "https://gr.ambafrance.org",
    },
  },
  TURKEY: {
    police: "155",
    pompiers: "110",
    samu: "112",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Turquie",
      adresse: "Paris Caddesi 70, 06540 Kavaklıdere, Ankara",
      telephone: "+90 312 455 45 45",
      telephone_urgence: "+90 312 455 45 45",
      site: "https://tr.ambafrance.org",
    },
  },
  UK: {
    police: "999 / 112",
    pompiers: "999",
    samu: "999 / 112",
    urgences_universelles: "999",
    ambassade_france: {
      nom: "Ambassade de France au Royaume-Uni",
      adresse: "58 Knightsbridge, London SW1X 7JT",
      telephone: "+44 20 7073 1000",
      telephone_urgence: "+44 20 7073 1000",
      site: "https://uk.ambafrance.org",
    },
  },
  GERMANY: {
    police: "110",
    pompiers: "112",
    samu: "112",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Allemagne",
      adresse: "Pariser Platz 5, 10117 Berlin",
      telephone: "+49 30 590 03 90 00",
      telephone_urgence: "+49 30 590 03 90 00",
      site: "https://de.ambafrance.org",
    },
  },

  // ── North Africa ───────────────────────────────────────────────────────────
  MOROCCO: {
    police: "19",
    pompiers: "15",
    samu: "15 / 150",
    urgences_universelles: "15",
    ambassade_france: {
      nom: "Ambassade de France au Maroc",
      adresse: "3 rue Sahnoun, Agdal, 10000 Rabat",
      telephone: "+212 537 68 97 00",
      telephone_urgence: "+212 537 68 97 00",
      site: "https://ma.ambafrance.org",
    },
  },
  TUNISIA: {
    police: "197",
    pompiers: "198",
    samu: "190",
    urgences_universelles: "190",
    ambassade_france: {
      nom: "Ambassade de France en Tunisie",
      adresse: "Place de l'Indépendance, 1002 Tunis",
      telephone: "+216 71 105 111",
      telephone_urgence: "+216 71 105 111",
      site: "https://tn.ambafrance.org",
    },
  },
  EGYPT: {
    police: "122",
    pompiers: "180",
    samu: "123",
    urgences_universelles: "123",
    ambassade_france: {
      nom: "Ambassade de France en Égypte",
      adresse: "29 Avenue Charles de Gaulle, Giza",
      telephone: "+20 2 3567 3200",
      telephone_urgence: "+20 2 3567 3200",
      site: "https://eg.ambafrance.org",
    },
  },

  // ── Sub-Saharan Africa ────────────────────────────────────────────────────
  SENEGAL: {
    police: "17",
    pompiers: "18",
    samu: "15",
    urgences_universelles: "15",
    ambassade_france: {
      nom: "Ambassade de France au Sénégal",
      adresse: "1 rue El Hadj Amadou Assane Ndoye, Dakar",
      telephone: "+221 33 839 51 00",
      telephone_urgence: "+221 33 839 51 00",
      site: "https://sn.ambafrance.org",
    },
  },
  KENYA: {
    police: "999 / 112",
    pompiers: "999",
    samu: "999 / 112",
    urgences_universelles: "999",
    ambassade_france: {
      nom: "Ambassade de France au Kenya",
      adresse: "Barclays Plaza, Loita Street, Nairobi",
      telephone: "+254 20 277 8000",
      telephone_urgence: "+254 20 277 8000",
      site: "https://ke.ambafrance.org",
    },
  },
  SOUTH_AFRICA: {
    police: "10111 / 112",
    pompiers: "10111",
    samu: "10177 / 112",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Afrique du Sud",
      adresse: "250 Melk Street, New Muckleneuk, Pretoria 0181",
      telephone: "+27 12 425 1600",
      telephone_urgence: "+27 12 425 1600",
      site: "https://za.ambafrance.org",
    },
  },
  NAMIBIA: {
    police: "10111 / 112",
    pompiers: "211111",
    samu: "112 / 061 211111",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Namibie",
      adresse: "1 Goethe St, Windhoek",
      telephone: "+264 61 276 900",
      telephone_urgence: "+264 61 276 900",
      site: "https://na.ambafrance.org",
    },
  },
  BOTSWANA: {
    police: "999 / 112",
    pompiers: "998",
    samu: "997",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France au Botswana",
      adresse: "761 Robinson Rd, Gaborone",
      telephone: "+267 397 3863",
      telephone_urgence: "+267 397 3863",
      site: "https://bw.ambafrance.org",
    },
  },
  MADAGASCAR: {
    police: "17",
    pompiers: "18",
    samu: "15",
    urgences_universelles: "15",
    ambassade_france: {
      nom: "Ambassade de France à Madagascar",
      adresse: "3 rue Jean Jaurès, Antananarivo 101",
      telephone: "+261 20 23 398 98",
      telephone_urgence: "+261 20 23 398 98",
      site: "https://mg.ambafrance.org",
    },
  },
  REUNION: {
    police: "17 / 112",
    pompiers: "18",
    samu: "15",
    urgences_universelles: "15",
    ambassade_france: {
      nom: "Préfecture de La Réunion (DOM français)",
      adresse: "Place du Barachois, Saint-Denis 97400",
      telephone: "+262 262 40 77 77",
      telephone_urgence: "15 / 17 / 18",
      site: "https://www.reunion.gouv.fr",
    },
  },
  MAURITIUS: {
    police: "112 / 999",
    pompiers: "115 / 999",
    samu: "114",
    urgences_universelles: "999",
    ambassade_france: {
      nom: "Ambassade de France à Maurice",
      adresse: "14 St Georges Street, Port Louis",
      telephone: "+230 202 0100",
      telephone_urgence: "+230 202 0100",
      site: "https://mu.ambafrance.org",
    },
  },

  // ── Asia ──────────────────────────────────────────────────────────────────
  JAPAN: {
    police: "110",
    pompiers: "119",
    samu: "119",
    urgences_universelles: "110 / 119",
    ambassade_france: {
      nom: "Ambassade de France au Japon",
      adresse: "4-11-44 Minami-Azabu, Minato-ku, Tokyo 106-8514",
      telephone: "+81 3 5798 6000",
      telephone_urgence: "+81 3 5798 6000",
      site: "https://jp.ambafrance.org",
    },
  },
  THAILAND: {
    police: "191 / 1155 (Touriste)",
    pompiers: "199",
    samu: "1669",
    urgences_universelles: "191",
    ambassade_france: {
      nom: "Ambassade de France en Thaïlande",
      adresse: "35 Customs House Lane, Bangkok 10500",
      telephone: "+66 2 657 5100",
      telephone_urgence: "+66 2 657 5100",
      site: "https://th.ambafrance.org",
    },
  },
  VIETNAM: {
    police: "113",
    pompiers: "114",
    samu: "115",
    urgences_universelles: "113",
    ambassade_france: {
      nom: "Ambassade de France au Vietnam",
      adresse: "57 Tran Hung Dao, Hoan Kiem, Hanoi",
      telephone: "+84 24 3944 5700",
      telephone_urgence: "+84 24 3944 5700",
      site: "https://vn.ambafrance.org",
    },
  },
  CAMBODIA: {
    police: "117",
    pompiers: "118",
    samu: "119",
    urgences_universelles: "117",
    ambassade_france: {
      nom: "Ambassade de France au Cambodge",
      adresse: "1 Boulevard Monivong, Phnom Penh",
      telephone: "+855 23 430 020",
      telephone_urgence: "+855 23 430 020",
      site: "https://kh.ambafrance.org",
    },
  },
  INDONESIA: {
    police: "110",
    pompiers: "113",
    samu: "118 / 119",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Indonésie",
      adresse: "Jl. MH Thamrin No. 20, Jakarta Pusat",
      telephone: "+62 21 2355 7600",
      telephone_urgence: "+62 21 2355 7600",
      site: "https://id.ambafrance.org",
    },
  },
  INDIA: {
    police: "100 / 112",
    pompiers: "101",
    samu: "108 / 112",
    urgences_universelles: "112",
    ambassade_france: {
      nom: "Ambassade de France en Inde",
      adresse: "2/50-E Shantipath, Chanakyapuri, New Delhi 110021",
      telephone: "+91 11 4319 6100",
      telephone_urgence: "+91 11 4319 6100",
      site: "https://in.ambafrance.org",
    },
  },
  SRI_LANKA: {
    police: "119",
    pompiers: "110",
    samu: "1990",
    urgences_universelles: "119",
    ambassade_france: {
      nom: "Ambassade de France au Sri Lanka",
      adresse: "89 Rosmead Place, Colombo 7",
      telephone: "+94 11 263 9400",
      telephone_urgence: "+94 11 263 9400",
      site: "https://lk.ambafrance.org",
    },
  },
  MALDIVES: {
    police: "119",
    pompiers: "118",
    samu: "102",
    urgences_universelles: "119",
    ambassade_france: {
      nom: "Ambassade de France aux Maldives (via Sri Lanka)",
      adresse: "89 Rosmead Place, Colombo 7, Sri Lanka",
      telephone: "+94 11 263 9400",
      telephone_urgence: "+94 11 263 9400",
      site: "https://lk.ambafrance.org",
    },
  },

  // ── Americas ──────────────────────────────────────────────────────────────
  USA: {
    police: "911",
    pompiers: "911",
    samu: "911",
    urgences_universelles: "911",
    ambassade_france: {
      nom: "Ambassade de France aux États-Unis",
      adresse: "4101 Reservoir Rd NW, Washington DC 20007",
      telephone: "+1 202 944 6000",
      telephone_urgence: "+1 202 944 6000",
      site: "https://us.ambafrance.org",
    },
  },
  CANADA: {
    police: "911",
    pompiers: "911",
    samu: "911",
    urgences_universelles: "911",
    ambassade_france: {
      nom: "Ambassade de France au Canada",
      adresse: "42 Sussex Drive, Ottawa, ON K1M 2C9",
      telephone: "+1 613 789 1795",
      telephone_urgence: "+1 613 789 1795",
      site: "https://ca.ambafrance.org",
    },
  },
  MEXICO: {
    police: "911",
    pompiers: "911",
    samu: "911",
    urgences_universelles: "911",
    ambassade_france: {
      nom: "Ambassade de France au Mexique",
      adresse: "Campos Elíseos 339, Polanco, Mexico City",
      telephone: "+52 55 9171 9700",
      telephone_urgence: "+52 55 9171 9700",
      site: "https://mx.ambafrance.org",
    },
  },
  BRAZIL: {
    police: "190",
    pompiers: "193",
    samu: "192",
    urgences_universelles: "190",
    ambassade_france: {
      nom: "Ambassade de France au Brésil",
      adresse: "SES Av. das Nações Lote 4, Brasília DF 70404-900",
      telephone: "+55 61 3222 3999",
      telephone_urgence: "+55 61 3222 3999",
      site: "https://br.ambafrance.org",
    },
  },
  PERU: {
    police: "105",
    pompiers: "116",
    samu: "117",
    urgences_universelles: "105",
    ambassade_france: {
      nom: "Ambassade de France au Pérou",
      adresse: "Av. Arequipa 3415, Miraflores, Lima",
      telephone: "+51 1 215 8400",
      telephone_urgence: "+51 1 215 8400",
      site: "https://pe.ambafrance.org",
    },
  },
  ARGENTINA: {
    police: "911",
    pompiers: "100",
    samu: "107",
    urgences_universelles: "911",
    ambassade_france: {
      nom: "Ambassade de France en Argentine",
      adresse: "Cerrito 1399, Buenos Aires C1010AAB",
      telephone: "+54 11 4515 7030",
      telephone_urgence: "+54 11 4515 7030",
      site: "https://ar.ambafrance.org",
    },
  },

  // ── Oceania ───────────────────────────────────────────────────────────────
  AUSTRALIA: {
    police: "000",
    pompiers: "000",
    samu: "000",
    urgences_universelles: "000",
    ambassade_france: {
      nom: "Ambassade de France en Australie",
      adresse: "6 Perth Avenue, Yarralumla, Canberra ACT 2600",
      telephone: "+61 2 6216 0100",
      telephone_urgence: "+61 2 6216 0100",
      site: "https://au.ambafrance.org",
    },
  },
  NEW_ZEALAND: {
    police: "111",
    pompiers: "111",
    samu: "111",
    urgences_universelles: "111",
    ambassade_france: {
      nom: "Ambassade de France en Nouvelle-Zélande",
      adresse: "Sovereign Assurance House, 34-42 Manners St, Wellington",
      telephone: "+64 4 384 2555",
      telephone_urgence: "+64 4 384 2555",
      site: "https://nz.ambafrance.org",
    },
  },

  // ── Default (generic) ─────────────────────────────────────────────────────
  DEFAULT: {
    police: "112 (Europe) / 911 (Amériques) / Numéro local",
    pompiers: "112 (Europe) / Numéro local",
    samu: "112 (Europe) / Numéro local",
    urgences_universelles: "112 (international GSM)",
    ambassade_france: {
      nom: "Ambassade de France — Localiser la plus proche",
      adresse: "Consultez l'annuaire des ambassades françaises",
      telephone: null,
      telephone_urgence: null,
      site: "https://www.diplomatie.gouv.fr/fr/le-ministere-et-son-reseau/ambassades-et-consulats/",
    },
  },
};

// ── Country detection ────────────────────────────────────────────────────────
const COUNTRY_KEYWORDS = {
  SPAIN: ["espagne", "spain", "madrid", "barcelone", "barcelona", "séville", "seville", "valence", "valencia", "ibiza", "majorque", "tenerife", "grenade", "málaga", "malaga"],
  PORTUGAL: ["portugal", "lisbonne", "lisbon", "porto", "algarve", "madère", "madeira", "açores", "azores"],
  ITALY: ["italie", "italy", "rome", "roma", "milan", "milano", "venise", "venice", "florence", "firenze", "naples", "napoli", "sicile", "sicily", "sardaigne", "sardinia", "amalfi"],
  GREECE: ["grèce", "greece", "athènes", "athens", "santorin", "santorini", "mykonos", "crète", "crete", "rhodes"],
  TURKEY: ["turquie", "turkey", "istanbul", "ankara", "cappadoce", "cappadocia", "antalya", "bodrum"],
  UK: ["royaume-uni", "angleterre", "england", "london", "londres", "écosse", "scotland", "pays de galles", "wales"],
  GERMANY: ["allemagne", "germany", "berlin", "munich", "hambourg", "hamburg", "cologne", "bavière"],
  MOROCCO: ["maroc", "morocco", "marrakech", "fès", "fez", "casablanca", "rabat", "essaouira", "agadir"],
  TUNISIA: ["tunisie", "tunisia", "tunis", "djerba", "hammamet", "sousse"],
  EGYPT: ["égypte", "egypt", "le caire", "cairo", "louxor", "luxor", "assouan", "aswan", "hurghada", "charm", "sharm"],
  SENEGAL: ["sénégal", "senegal", "dakar", "saint-louis", "ziguinchor"],
  KENYA: ["kenya", "nairobi", "mombasa", "safari", "masaï mara", "masai mara", "amboseli"],
  SOUTH_AFRICA: ["afrique du sud", "south africa", "cape town", "johannesburg", "durban", "stellenbosch"],
  NAMIBIA: ["namibie", "namibia", "windhoek", "swakopmund", "etosha", "sossusvlei"],
  BOTSWANA: ["botswana", "gaborone", "okavango", "chobe", "maun"],
  MADAGASCAR: ["madagascar", "antananarivo", "tana", "nosy be", "morondava"],
  REUNION: ["réunion", "reunion", "saint-denis", "saint-pierre", "saint-gilles"],
  MAURITIUS: ["maurice", "mauritius", "port louis", "mahébourg"],
  JAPAN: ["japon", "japan", "tokyo", "osaka", "kyoto", "hiroshima", "nara", "okinawa", "hokkaido", "nagoya"],
  THAILAND: ["thaïlande", "thailand", "bangkok", "phuket", "chiang mai", "krabi", "koh samui", "pattaya", "hua hin"],
  VIETNAM: ["vietnam", "hanoï", "hanoi", "ho chi minh", "saigon", "hoi an", "hue", "da nang", "halong"],
  CAMBODIA: ["cambodge", "cambodia", "phnom penh", "siem reap", "angkor"],
  INDONESIA: ["indonésie", "indonesia", "bali", "jakarta", "lombok", "java", "komodo", "yogyakarta"],
  INDIA: ["inde", "india", "delhi", "bombay", "mumbai", "bangalore", "goa", "rajasthan", "kerala"],
  SRI_LANKA: ["sri lanka", "colombo", "kandy", "sigiriya"],
  MALDIVES: ["maldives", "malé", "male", "atoll"],
  USA: ["états-unis", "usa", "new york", "los angeles", "miami", "san francisco", "chicago", "las vegas", "hawaii", "boston", "washington"],
  CANADA: ["canada", "montréal", "montreal", "toronto", "vancouver", "québec", "quebec", "calgary"],
  MEXICO: ["mexique", "mexico", "cancun", "cancún", "playa del carmen", "tulum", "oaxaca", "guadalajara"],
  BRAZIL: ["brésil", "brazil", "rio de janeiro", "rio", "são paulo", "sao paulo", "salvador", "fortaleza", "florianópolis", "manaus"],
  PERU: ["pérou", "peru", "lima", "machu picchu", "cusco", "cuzco", "arequipa"],
  ARGENTINA: ["argentine", "argentina", "buenos aires", "patagonie", "patagonia", "mendoza", "bariloche"],
  AUSTRALIA: ["australie", "australia", "sydney", "melbourne", "brisbane", "cairns", "perth", "gold coast"],
  NEW_ZEALAND: ["nouvelle-zélande", "new zealand", "auckland", "queenstown", "wellington", "christchurch"],
};

function normalize(str) {
  return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function detectCountry(destination = "") {
  const d = normalize(destination);
  for (const [country, keywords] of Object.entries(COUNTRY_KEYWORDS)) {
    if (keywords.some((kw) => d.includes(normalize(kw)))) {
      return country;
    }
  }
  return "DEFAULT";
}

// ── Merge Claude data + static fallback ─────────────────────────────────────
export function getEmergencyInfo(destination, claudeUrgences) {
  const country = detectCountry(destination);
  const staticData = EMERGENCY_DATA[country] || EMERGENCY_DATA.DEFAULT;

  return {
    police: claudeUrgences?.police || staticData.police,
    pompiers: claudeUrgences?.pompiers || staticData.pompiers,
    samu: claudeUrgences?.samu_ambulance || staticData.samu,
    urgences_universelles: claudeUrgences?.numero_unique_urgences || staticData.urgences_universelles,
    hopital: claudeUrgences?.hopital_reference || null,
    ambassade: staticData.ambassade_france,
    countryKey: country,
  };
}
